module.exports = __webpack_public_path__ + "static/media/bottlings4.bb951141.jpg";